<ng-template #storypopup>
  <div class="content">
    <div class="close">
      <a (click)="close()"><mat-icon>close</mat-icon></a>
    </div>
    <div class="banner">
      <app-story-v3-banner [config]="{fundraiser: fundraiser, warning_text: 'Urgent need of funds', show_end_date: true}"></app-story-v3-banner>
    </div>
    <div class="below-content">
      <div class="title">Your donation will help save {{fundraiser?.beneficiaryname?.info_1}}'s life.</div>
      <button class="donate-btn" *ngIf="!isMobile" (click)="scroll()">Donate Now</button>
      <app-donate-now *ngIf="isMobile" label="Donate Now" [fundraiser]="fundraiser" (click)="sendSystemEvent()"></app-donate-now>
      <div class="data-shown">
        <img [src]="lastDonor?.image !== '' ? lastDonor?.image : '/assets/images/user-image.png'" alt="user">
        <span>{{lastDonor?.name}} Donated Just Now</span>
      </div>
    </div>
  </div>
</ng-template>